import FacetedSearch from 'ps-components/redux/facetedSearch';
import apiClient from 'ps-components/lib/apiClient';
const nameSpace = 'SLOTTED_SEARCH';

const initialState = {
  filtersAreOpen: false,
  facetSelection: {},
  facets: [],
  loading: false,
  loaded: false,
  error: null,
  items: [],
  query: '',
  showAddButton: true,
  resetFacetText: 'Reset Filters',
  filters: {},
  facetIsCheckedByDefault: true,
  showZeros: false,
  sortBy: 'label',
  offset: 0,
  limit: 50
};

const options = {
  apiClient,
  graphql: { apiClient },
  getInstanceState: store => store.marketPricing.SlottedSearchReducer.slottedSearchFacetReducer,
  useCMS: true,
  genericGridParams: store => {
    let currentJob;
    if (store?.orgJobs?.jobs) {
      currentJob = store?.orgJobs?.jobs[0];
    }

    const displayIn = store?.marketPricing?.MarketPricingReducer?.displayIn;
    const currentCurrency = currentJob?.currency;
    const currency = store?.marketPricing?.SlottedSearchReducer?.slottedSearchReducer?.currency || currentCurrency;

    return {
      data: {
        ...currentJob,
        page_code: 'slot_job',
        page_pk: 4,
        category_code: 'jobs',
        currency
      },
      displayIn,
      filter: { where: { and: [] } },
      isSlotted: true
    };
  }
};
export const slottedSearchJobFacetSearch = new FacetedSearch(nameSpace, initialState, options);

function extendReducer(state, action) {
  switch (action.type) {
    default:
      return null;
  }
}

export const reducer = slottedSearchJobFacetSearch.createReducer(extendReducer, {
  searchAPI: '/cms/api/accounts/{{masterAccountId}}/org-jobs'
});

///////////////////////////////////
//           ACTIONS             //
///////////////////////////////////

export const slottedSearchJobFacetSearchActions = slottedSearchJobFacetSearch.getActions();
